
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"18","viewBox":"0 0 17 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.906 13.875H2.937A.938.938 0 012 12.937v-7.5a.937.937 0 01.938-.937h7.968a.938.938 0 01.938.938V7.34l2.54-1.814a.468.468 0 01.741.38v6.562a.469.469 0 01-.74.38l-2.541-1.815v1.903a.938.938 0 01-.938.938z","fill":"#07193D","fill-opacity":".6"}})])
          )
        }
      }
    